import easydropdown from 'easydropdown';

export default {
  init() {
    // JavaScript to be fired on the home page

    function selectInit() {
      const main = document.querySelector('main.main'),
        form = main.querySelector('.js-wpv-filter-form'),
        activeFilters = main.querySelector('.js-wpv-active-filters'),
        activeFiltersList = main.querySelector('.js-wpv-active-filters-list'),
        selectElements = form.querySelectorAll('select');

      var selectedOptions = [];

      selectElements.forEach(select => {
        var selectedOption = select.querySelector('option[selected]');

        if (selectedOption.value !== '0') {
          selectedOptions.push({
            name: select.name,
            value: selectedOption.value,
            text: selectedOption.text,
          });
        }

        easydropdown(select, {
          behavior: {
            useNativeUiOnMobile: false,
            openOnFocus: false,
          },
        });
      });

      if (selectedOptions.length) {
        activeFilters.classList.remove('d-none');

        selectedOptions.forEach(option => {
          var button = document.createElement('button');

          button.innerHTML = option.text;
          button.classList.add('filter-button');
          button.addEventListener('click', function() {
            var targetSelect = form.querySelector(
              `select[name="${option.name}"]`
            );

            targetSelect.value = 0;

            form.submit();
          });

          activeFiltersList.appendChild(button);
        });
      }
    }

    selectInit();

    $(document).ready(function() {
      $(document).on('js_event_wpv_pagination_completed', function() {
        selectInit();
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/archiveProfessionisti.js